import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import TeamCall from '../components/TeamCall';
import OwnerMsgTeam from '../components/OwnerMsgTeam';
import AboutUsComponent from '../components/AboutUsComponent';
import { teamMembers } from '../data/TeamBiosData';
import '../styles/teamPage.css';
import CTASection from '../components/CTASection';
import { useLocation } from 'react-router-dom';

const TeamPage = () => {
  const location = useLocation();

  // Split into leadership (original list) vs new sections
  const leadership = teamMembers.filter(m => !m.disableHover);

  // Combine foremen and field team, then sort by years with company
  const foremanTeam = teamMembers
    .filter(m => m.disableHover)
    .sort((a, b) => {
      const yearsA = parseInt(a.yearsWithCompany) || 0;
      const yearsB = parseInt(b.yearsWithCompany) || 0;
      return yearsB - yearsA; // Descending order (most years first)
    });

  // Handle hash navigation (e.g., #positions)
  useEffect(() => {
    // Check if there's a hash in the URL
    const hash = location.hash;
    if (hash) {
      // Small delay to ensure the page has rendered
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="team-page">
      <Navbar/>

      <section className="team-hero-overlay">
      <div>
          <img
            src="/images/team/menAtWork.JPG"
            alt="All Seasons Tree Logo"
            className="hero-image"
            loading="eager"
            decoding="async"
          />
        </div>
        <div className="team-hero-content">
          <h1 className="team-hero-title">Meet the People who make the difference</h1>
          <p className="team-hero-subtitle">PASSIONATE PROFESSIONALS AND CRAFTSMEN DEDICATED TO EXCELLENCE THROUGH EVERY SEASON</p>

          <div className="team-hero-buttons">
            <a href="#team-members" className="btn-cta">Meet Our Team</a>
            <a href="#apply" className="btn-primary">Join Our Team</a>
          </div>
        </div>
        <div className="team-hero-decoration"></div>
      </section>

      {/* About All Seasons - Default Version */}
      <AboutUsComponent variant="default" />

      <OwnerMsgTeam/>
      {/* Team at Work Section */}
      {/* <section className="team-at-work-section">
        <div className="team-at-work-container">
          <div className="team-at-work-header">
            <h2>See Our Team in Action</h2>
            <p>Watch our skilled professionals transform landscapes across Idaho</p>
          </div>
          
          <div className="team-work-preview">
            <div className="work-image-grid">
              <div className="work-image-card main">
                <img src="/images/team/teamAtWork.jpg" alt="Team working on landscape project" />
                <div className="work-overlay">
                  <h3>Crafting Beautiful Landscapes</h3>
                  <p>Every Day</p>
                </div>
              </div>
              <div className="work-image-card">
                <img src="/images/maintenance/hoaLand.JPG" alt="Installation work" />
                <div className="work-overlay">
                  <h4>Installation</h4>
                  <p>Expert installation services</p>
                </div>
              </div>
              <div className="work-image-card">
                <img src="/images/maintenance/actionSpary.JPG" alt="Maintenance work" />
                <div className="work-overlay">
                  <h4>Maintenance</h4>
                  <p>Ongoing landscape care</p>
                </div>
              </div>
              <div className="work-image-card">
               <img src="/images/design/bedPond.jpg" alt="Design Creation" />
                <div className="work-overlay">
                  <h4>Design</h4>
                  <p>Creative landscape solutions</p>
                </div>
              </div>
            </div>
            
            <div className="team-work-cta">
              <a href="/gallery/teamAction" className="btn-cta">View Team Gallery</a>
              <p className="work-gallery-note">See more photos of our team at work</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Leadership / original list */}
      <section id="team-members" className="team-members-section">
        <div className="team-members-header">
          <h2>Meet Our All Seasons Family</h2>
          <p>Get to know the dedicated professionals who bring your landscape visions to life</p>
        </div>

        <div className="team-cards-grid">
          {leadership.map((member, index) => (
            <TeamMemberCard key={index} member={member} />
          ))}
        </div>
      </section>

      {/* Foreman Team - Combined and sorted by years with company */}
      {foremanTeam.length > 0 && (
        <section className="team-members-section">
          <div className="team-members-header">
            <h2>Foreman Team</h2>
            <p>Field leaders and specialists bringing expertise across construction, maintenance, irrigation, and plant health.</p>
          </div>

          <div className="team-cards-grid team-cards-grid-static">
            {foremanTeam.map((member, index) => (
              <TeamMemberCard key={`foreman-${index}`} member={member} />
            ))}
          </div>
        </section>
      )}

      <TeamCall />

      {/* Team Holiday Gathering */}
      <section className="team-gathering-section">
        <div className="section-inner">
          <div className="gathering-header">
            <h2 className="section-title">Celebrating Together</h2>
            <p className="section-subtitle">Our annual holiday gathering brings the entire All Seasons family together to celebrate another successful year</p>
          </div>

          <div className="gathering-gallery">
            <div className="gathering-image">
              <img
                src="/images/team/party/Party4.png"
                alt="All Seasons team celebration"
                loading="lazy"
              />
              <div className="gathering-badge">HOLIDAY PARTY</div>
            </div>
            <div className="gathering-image">
              <img
                src="/images/team/party/Party2.jpeg"
                alt="Team members at holiday party"
                loading="lazy"
              />
            </div>
            <div className="gathering-image gathering-image--wide">
              <img
                src="/images/team/party/Party1.jpg"
                alt="All Seasons holiday gathering"
                loading="lazy"
              />
            </div>
            <div className="gathering-image gathering-image--wide">
              <img
                src="/images/team/party/Party3.jpg"
                alt="Holiday celebration"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
       {/* CTA Section */}

      {/* Benefits Section */}
      <section className="section why-all-seasons-hero">
        <div className="section-inner">
          <div className="text-center mb-4">
            <h2 className="section-title">Working At All Seasons</h2>
          </div>
          
          <div className="value-props-grid">
            <div className="value-prop-card featured">
              <div className="value-number">35+</div>
              <h3>Years of Stability</h3>
              <p className="value-description">
                Join a company with over three decades of growth and success in the Wood River Valley.
              </p>
            </div>
            
            <div className="value-prop-card">
              <div className="value-number">$$$</div>
              <h3>Competitive Wages</h3>
              <p className="value-description">
                We offer industry-leading pay with overtime opportunities and performance bonuses.
              </p>
            </div>
            
            <div className="value-prop-card">
              <div className="value-number">60+</div>
              <h3>Growing Team</h3>
              <p className="value-description">
                Join Idaho's largest landscaping team with opportunities for advancement and leadership.
              </p>
            </div>
            
            <div className="value-prop-card">
              <div className="value-number">365</div>
              <h3>Year-Round Opportunity</h3>
              <p className="value-description">
                Seasonal and full-time positions available with flexible scheduling options.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* BambooHR Job Embed */}
      <section id="positions" className="positions-section">
        <div className="section-inner">
          <h2 className="section-title">Open Positions</h2>
          <div className="bamboo-container" style={{
            minHeight: '400px',
            marginTop: '2rem',
            background: '#fff',
            borderRadius: '12px',
            padding: '2rem',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(47, 93, 80, 0.1)'
          }}>
            <iframe
              src="https://allseasons.bamboohr.com/careers"
              width="100%"
              height="600"
              style={{
                border: 'none',
                borderRadius: '8px',
                display: 'block',
                background: '#f5f5f5'
              }}
              title="All Seasons Job Listings"
              loading="lazy"
            />
          </div>
        </div>
      </section>
     <CTASection 
  title="Ready to Grow With Us?"
  subtitle="We're always looking for dedicated, skilled team members—seasonal or year-round. Apply today and let's build something great together."
  galleryLink="/Gallery/teamAction"
  showEmergency={false}
/>
    </div>
  );
};

// Card component that adapts:
const TeamMemberCard = ({ member }) => {
  const [showBio, setShowBio] = useState(false);
  const isStatic = !!member.disableHover;

  if (isStatic) {
    return (
      <div className="team-member-card no-hover v2">
        <div className="card-content static">
          <img
            src={member.image || '/images/team/placeholder.jpg'}
            alt={member.name ? `${member.name} — ${member.role}` : 'Team member'}
            className="member-image static"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.src = '/images/team/placeholder.jpg';
            }}
          />

          {/* New bottom overlay for static cards */}
          <div className="static-overlay">
            <h3 className="member-name">{member.name}</h3>
            <p className="member-role">{member.role}</p>
            {member.yearsWithCompany && (
              <p className="member-years">
                Years with All Seasons: {member.yearsWithCompany}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
  // Original interactive layout
   return (
    <div className="team-member-card">
      <div className="card-content">
        <div className={`bio-overlay ${showBio ? 'mobile-visible' : ''}`}>
          <div className="bio-header">
            <h3 className="member-name">{member.name}</h3>
            <p className="member-role">{member.role}</p>
          </div>
          <div className="bio-text-full desktop-only">{member.bio}</div>
          <div className="bio-text-brief desktop-only">{member.briefBio || member.bio.substring(0, 150) + '...'}</div>
          <div className="bio-text-mobile mobile-only">{member.mobileBio || member.briefBio || member.bio.substring(0, 120) + '...'}</div>

          {member.personalityHighlight && (
            <div className="personality-highlight">
              <span className="highlight-icon">✨</span>
              {member.personalityHighlight}
            </div>
          )}

          {member.projectLink && member.projectLabel && (
            <a href={member.projectLink} className="member-project-link">
              {member.projectLabel}
            </a>
          )}

          {/* Mobile back button - only visible on mobile when showing bio */}
          <button
            className="mobile-back-button"
            onClick={() => setShowBio(false)}
          >
            Back to Photo
          </button>
        </div>

        <div className={`image-container ${showBio ? 'mobile-hidden' : ''}`}>
          <img
            src={member.image || '/images/team/placeholder.jpg'}
            alt={member.name}
            className="member-image"
          />

          {/* Mobile flip button - only visible on mobile */}
          <button
            className="mobile-flip-button"
            onClick={() => setShowBio(true)}
          >
            View Bio
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
